@if (views?.length) {
    <li class="list-group-item d-flex align-items-center" [title]="title">
        <h6>{{ title }}</h6>
    </li>
}

@for (view of views; track view.id; let i = $index) {
    <button
        class="list-group-item list-group-item-action justify-content-between align-items-center py-0"
        type="button"
        [attr.data-cy]="'filter-' + view?.name | translateTokenisedString"
        [title]="view?.name | translateTokenisedString"
        [class.active]="view?.id === (filterQueryService?.view$ | ngrxPush)?.id"
        [class.d-none]="i >= records && !showMore"
        [class.d-flex]="i < records || showMore"
        [attr.aria-current]="
            view?.id === (filterQueryService?.view$ | ngrxPush)?.id
        "
    >
        <div
            class="d-flex w-100 py-3"
            [innerHtml]="view?.name | translateTokenisedString | safeHtml"
            (click)="updateSelectedView(view)"
        ></div>
        @if (!config?.disableBuilder) {
            <div class="d-flex">
                @if (viewsType === personal) {
                    <atom-icon-button
                        class="ms-2"
                        size="sm"
                        icon="trash-alt"
                        [title]="'Delete ' + view?.name"
                        (onClick)="deletePersonalView(view)"
                        [attr.data-cy]="'delete-item-filter-' + view?.name"
                    ></atom-icon-button>
                }
                @if (FEATURE_FLAG_CUSTOM_VIEWS | hasFeature) {
                    <atom-icon-button
                        class="ms-2"
                        size="sm"
                        [title]="
                            (viewsType === 'personal' ? 'Edit ' : 'Clone ') +
                            (view?.name | translateTokenisedString)
                        "
                        [icon]="viewsType === personal ? ICON_EDIT : ICON_CLONE"
                        (click)="toggleQueryBuilder(view)"
                    ></atom-icon-button>
                }
            </div>
        }
    </button>
}

@if (views?.length > records) {
    <section>
        <button
            class="list-group-item list-group-item-action see-more"
            type="button"
            (click)="toggle()"
        >
            @if (!showMore) {
                <span> {{ MENU_SEEMORE | translateTokenisedString }} </span>
            }
            @if (showMore) {
                <span>{{ MENU_SEE_LESS | translateTokenisedString }}</span>
            }
        </button>
    </section>
}
